export default "__VITE_ASSET__CgNEXOC8__"